<template>
    <base-frame :isMe="isMe" :userType="msgObj.userType"  chatmessageCls="msg-img" :sendType="msgObj.msgStatus" @iconClick="iconClick">
      <img slot="chatmessage" :src="msgObj.content" v-bind="{'width': msgObj.width,'imgWidth': msgObj.imgWidth, 'imgHeight': msgObj.imgHeight}">
    </base-frame>
</template>

<script>
import BaseFrame from './BaseFrame'
export default {
  name: 'tpl-image',
  components: {
    BaseFrame
  },
  props: {
    msgObj: Object,
    isMe: Boolean
  },
  methods: {
    iconClick(type) {
      if (type == 3) {
        Bus.$emit("sendMsg", this.msgObj);
      }
    }
  }
}
</script>

<style>
.msg-img {
  padding: 0;
  background: transparent;
  display: inline-block;
  position: relative;
}

.msg-img img{
  max-height: 180px;
  max-width: 100%;
  border-radius: 5px;
}
</style>




// WEBPACK FOOTER //
// src/components/templates/TplImage.vue